import { useQuery } from "@tanstack/react-query";
import adminApiClient, { HeartLongPressStatsResponse } from "api/admin";

export default function useHeartLongPressStats(days: number) {
  return useQuery<HeartLongPressStatsResponse>({
    queryKey: ["heartLongPressStats", days],
    queryFn: () => adminApiClient.getHeartLongPressStats({ days }),
  });
}
